// libs import
import Vue from 'vue';
import VueRouter from 'vue-router';
import vClickOutside from 'v-click-outside';
import Moment from 'vue-moment';
import Chartist from 'chartist';
import VeeValidate from 'vee-validate';
import VueInstant from 'vue-instant';
import VueStomp from "./plugins/vue-stopm";
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import VueQRCodeComponent from 'vue-qrcode-component'
import VueBarcode from 'vue-barcode';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
// plugins import
import SessionService from "./services/session";
import SideBar from './components/Shared/SidebarPlugin';
import Trainings from './components/Trainings/Trainings';
import WebsocketConfiguration from './websocketConfiguration'
import SharedComponents from './sharedComponents';
// import firebase from 'firebase'
import firebase from 'firebase/app';
import 'firebase/database';

import App from './App';

// routes
import routes from './routes/routes';

// packages import
import 'bootstrap/dist/css/bootstrap.css';
import 'sweetalert2/dist/sweetalert2.css';
import 'vue-instant/dist/vue-instant.css';
import 'es6-promise/auto';
import 'vue2-loading-bar';

// styles inject
import 'vue-plyr/dist/vue-plyr.css';
import Plyr from "vue-plyr";
import './assets/sass/app.scss';
import Users from "./components/Users/Users";
import AddUser from "./components/Users/Add/AddUser";
import EditUser from "./components/Users/Edit/EditUser";
import UserPayment from "./components/Users/Payment/UserPayment";
import AddPayment from "./components/Users/Payment/Add/AddPayment";
import Term from "./components/Term/Term";
import AddTerm from "./components/Term/Add/AddTerm";
import EditTerm from "./components/Term/Edit/EditTerm";
import AddTraining from "./components/Trainings/Add/AddTraining";
import ViewTrainings from "./components/Trainings/View/ViewTrainings";
import EditTraining from "./components/Trainings/Edit/EditTraining";
import TrainingReport from "./components/TrainingReport/TrainingReport";
import EditPayment from "./components/Users/Payment/Edit/EditPayment";
import AcceptTerms from "./components/Account/AcceptTerms";
import Rules from "./components/Account/Rules";
import Notification from "./components/Notification/Notification";
import ResetPassword from "./components/Account/ResetPassword";
import OpenTerms from "./components/Term/Open/OpenTerms";
import PaymentReport from "./components/Payment/PaymentReport";

const firebaseConfig = {
    apiKey: "AIzaSyBMEbB_1k9vsordnjdPfvW2kA2zux-zU6g",
    authDomain: "crossfitns-877ea.firebaseapp.com",
    databaseURL: "https://crossfitns-877ea.firebaseio.com",
    projectId: "crossfitns-877ea",
    storageBucket: "crossfitns-877ea.appspot.com",
    messagingSenderId: "842251154987",
    appId: "1:842251154987:web:de1a5db2515c62761c9c6e"
};


firebase.initializeApp(firebaseConfig);
// Get a reference to the database service
var db = firebase.database();
window.db = db;

// plugin setup
Vue.use(VueRouter);
Vue.use(vClickOutside);
Vue.use(SideBar);
Vue.use(VeeValidate);
Vue.use(Moment);
Vue.use(VueInstant);
Vue.use(SharedComponents)
Vue.use(VueStomp);
Vue.use(Trainings);
Vue.use(Users);
Vue.use(AddUser);
Vue.use(EditUser);
Vue.use(UserPayment);
Vue.use(AddPayment);
Vue.use(Term);
Vue.use(AddTerm);
Vue.use(EditTerm);
Vue.use(AddTraining);
Vue.use(ViewTrainings);
Vue.use(EditTraining);
Vue.use(TrainingReport);
Vue.use(EditPayment);
Vue.use(AcceptTerms);
Vue.use(Rules);
Vue.use(Notification);
Vue.use(ResetPassword);
Vue.use(OpenTerms);
Vue.use(PaymentReport);
Vue.use(VueMaterial);
Vue.use(pdfMake);
Vue.use(VueQRCodeComponent);
Vue.use(firebase)
// Vue.component('qr-code', VueQRCodeComponent)
Vue.component('barcode', VueBarcode)

//
// configure router
const router = new VueRouter({
    routes, // short for routes: routes
    linkActiveClass: 'active'
});

export const EventBus = new Vue();
export const TopNavbar = new Vue();
export const Loader = new Vue();
export const MyTrainings = new Vue();

Vue.prototype.$eventBus = EventBus;
Vue.prototype.$topnavbar = TopNavbar;
Vue.prototype.$loader = Loader;
Vue.prototype.$trainingBus = MyTrainings;


SessionService.init(router);
Vue.prototype.$sessionService = SessionService;

const initialThemeMode = localStorage.getItem('THEME_MODE') === 'light' ? 'light' : 'dark';
document.body.classList.remove('theme-dark', 'theme-light');
document.body.classList.add(initialThemeMode === 'light' ? 'theme-light' : 'theme-dark');

EventBus.$on('print-something', function () {
    console.log('something');
});

// global library setup
Object.defineProperty(Vue.prototype, '$Chartist', {
    get() {
        return this.$root.Chartist
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    render: h => h(App),
    router,
    mounted() {
        //new WebsocketConfiguration(this, "http://localhost:8080/pushnotifications");
    },
    stompClient:{
        monitorIntervalTime: 100,
        stompReconnect: true
    }
})



// WEBPACK FOOTER //
// ./src/main.js